module.exports = __webpack_public_path__ + "static/img/6-100.ae14ecd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video-slider/6-100.jpg
// module id = i6r3
// module chunks = 2